import { ofType } from "redux-observable";
import { from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { ReplacementLoca } from "../../../utils/i18n/ReplacementLoca";
import { actionAppsflyerUpdate, TypeActionAppsflyer, } from "../actionAppsflyer";
import { IdAppsflyerEvents } from "../IdAppsflyerEvents";
export var epicAppsflyerPurchase = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionAppsflyer.Purchase), switchMap(function (action) {
        var purchaseEventName = action.isFirstPurchase
            ? IdAppsflyerEvents.FIRST_PURCHASE
            : IdAppsflyerEvents.PURCHASE;
        var PUClusterEventName = IdAppsflyerEvents.PU_CLUSTER_PURCHASED.replace(ReplacementLoca.zero_0, action.packageId);
        var eventValue = action.isFirstPurchase
            ? {}
            : {
                CURRENCY: action.currency,
                REVENUE: action.price,
            };
        return from([
            actionAppsflyerUpdate(purchaseEventName, eventValue),
            actionAppsflyerUpdate(PUClusterEventName, eventValue),
        ]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/appsflyer/epics/epicAppsflyerPurchase.ts
// module id = 1775
// module chunks = 3